import { HEX, RGB } from '@da-g3-acl/shared/common/colour-types';

import { toRGBObject } from '../components/CoreLane/CoreLaneRows/NumericPointsLaneRow/useGradients';

export function RGBToHex(colour: RGB): HEX {
	const { red, green, blue } = toRGBObject(colour);
	return ('#' +
		[red, green, blue]
			.map((x) => {
				const hex = x.toString(16);
				return hex.length === 1 ? '0' + hex : hex;
			})
			.join('')) as HEX;
}
// YIQ equation from http://24ways.org/2010/calculating-color-contrast
export const isYIQDark = (hexColour: HEX): boolean => {
	const r = parseInt(hexColour.substring(1, 3), 16);
	const g = parseInt(hexColour.substring(3, 5), 16);
	const b = parseInt(hexColour.substring(5, 7), 16);
	const yiq = (r * 299 + g * 587 + b * 114) / 1000;
	return yiq < 128;
};
